<template>
  <section class="section container pt-0">
    <inventory-status-datatable />
  </section>
</template>

<script>
import InventoryStatusDatatable from "./inventory_status_datatable/Index.vue";

export default {
  name: "InventoryStatus",
  components: {
    InventoryStatusDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
